import { render } from "./pdfViewerTemplate.vue?vue&type=template&id=1d295948"
import script from "./pdfViewerTemplate.vue?vue&type=script&lang=js"
export * from "./pdfViewerTemplate.vue?vue&type=script&lang=js"

import "./pdfViewerTemplate.vue?vue&type=style&index=0&id=1d295948&lang=scss"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__